<template>
  <div class="c-user-pic-wrap">
    <div class="c-user-pic" v-for="user in showUsers" :key="user[props.id]">
      <img
        v-if="user[props.pic] && user[props.pic] !== 'null'"
        :src="user[props.pic]"
        class="c-user-pic-img"
      >
      <span
        v-else
        class="c-user-pic-text"
      >{{ user.name ? user.name.substr(0,1) : '' }}</span>
    </div>
    <span
      v-if="users.length > maxLength"
      class="c-user-pic-num"
    >{{ users.length }}</span>
  </div>
</template>
<script>
export default {
  name: 'UserPicList',
  props: {
    users: Array,
    maxLength: Number,
    props: {
      type: Object,
      default () {
        return {
          id: 'id',
          pic: 'pic'
        }
      }
    }
  },
  computed: {
    showUsers () {
      return this.maxLength ? this.users.slice(0, this.maxLength) : this.users.slice(0)
    }
  }
}
</script>
<style lang="stylus">
.c-user-pic-wrap
  display flex
  flex-wrap nowrap
  .c-user-pic
    display flex
    flex-wrap nowrap
    &-img
      width 30px
      height 30px
      margin-left -8px
      border 1px solid #ffffff
      border-radius 50%
    &-text
      width 30px
      height 30px
      margin-left -8px
      border 1px solid #ffffff
      border-radius 50%
      text-align center
      font-size 14px
      line-height 30px
      color #ffffff
      background: #fdba78
    &-num
      background: #fdba78
      width 30px
      height 30px
      line-height 30px
      margin-left -8px
      border 1px solid #fff
      border-radius 50%
      text-align center
      color #fff
</style>
